import EditUserForm from './EditUserForm';

export default EditUserForm;
